import * as Sentry from '@sentry/react';

/**
 * @param dsn {string}  The DSN (Data Source Name) tells the SDK where to send events
 * 
 * @see https://docs.sentry.io/sdks/javascript/
 */
export default (dsn, environment = null) => {
    Sentry.init({
        dsn: dsn,
    });

    return {
        setUser: (id = null, email = null) => {
            if (!id && !email) {
                return;
            }

            Sentry.configureScope(scope => {
                let userObject = {};

                if (id) {
                    userObject = Object.assign({}, userObject, {id: id});
                }

                if (email) {
                    userObject = Object.assign({}, userObject, {email: email});
                }

                scope.setUser(userObject);
            });
        },

        setAccount: (accountId) => {
            if (!accountId || typeof accountId !== 'string') {
                throw new Error('Expected AccountId as string');
            }

            Sentry.configureScope(scope => {
                scope.setTag('account.id', null);
              });
        },

        setExtraContext: () => {
            Sentry.configureScope(scope => {
                // scope.setExtra('battery', 0.7);
            });
        },

        /**
         * @param err {Error} Exception to capture
         * 
         * @return void
         */
        captureException: (err) => {
            if (!err instanceof Error) {
                return;
            }

            Sentry.captureException(err);
        },

        /**
         * @param message {string} message to capture
         * 
         * @return void
         */
        captureMessage: (message) => {
            if (typeof message !== 'string') {
                return;
            }

            Sentry.captureMessage(message);
        },
    }
};
